import {
    Address,
    ContractFunction,
    ProxyProvider,
    QueryResponse,
    SmartContract,
    TypedValue,
} from '@elrondnetwork/erdjs/out'
import { network } from '../config'

export const fetchQueryHex = (
    method: string,
    args: TypedValue[],
    address: string
) =>
    new Promise<string>(async (resolve, reject) => {
        const contract = new SmartContract({ address: new Address(address) })
        const provider = new ProxyProvider(network.gatewayAddress || '')
        const response = await contract.runQuery(provider, {
            func: new ContractFunction(method),
            args: args,
        })
        if (response.isSuccess()) {
            if (response.returnData !== undefined) {
                const [encoded] = response.returnData
                if (!encoded) resolve('-1')
                const decoded = Buffer.from(encoded || '', 'base64').toString(
                    'hex'
                )
                resolve(decoded)
            }
        } else {
            reject('Something went wrong')
        }
    })

export const fetchQueryResponse = (method: any, args: any, address: any) =>
    new Promise<QueryResponse>(async (resolve, reject) => {
        const contract = new SmartContract({ address: new Address(address) })
        const provider = new ProxyProvider(network.gatewayAddress || '')
        const response = await contract.runQuery(provider, {
            func: new ContractFunction(method),
            args: args,
        })

        if (response.isSuccess()) {
            resolve(response)
        } else {
            reject('Something went wrong')
        }
    })
